import { useEffect } from 'react';
import { Nav } from '@/marketing/blocks/nav';
import { Footer } from '@/marketing/blocks/footer';
import { FinalCTA } from '@/marketing/blocks/final-cta';
import { PricingSection } from '@/marketing/blocks/pricing-section';
import { FAQSection } from '@/marketing/blocks/faq-section';
import { TweaksPanel } from '@/marketing/blocks/tweaks/TweaksPanel';
import { usePublicTweaks } from '@/marketing/queries/useTweaks';
import { useAuthStore } from '@/platform/stores/useAuthStore';
import { applyTheme } from '@/platform/applyTheme';
import { useCopy } from '@/i18n';

type CtaCopy = { primary: string; secondary: string };
const CTA_FALLBACK: CtaCopy = { primary: 'Start free today', secondary: 'See how it works' };

export default function Pricing() {
  const { tweaks } = usePublicTweaks();
  const isAdmin = useAuthStore((s) => s.user?.role === 'admin');
  const copy = useCopy();
  const ctaCopy = copy<CtaCopy>(`ctas.${tweaks.ctaCopy}`) ?? CTA_FALLBACK;

  useEffect(() => {
    applyTheme(tweaks);
  }, [tweaks]);

  return (
    <>
      <Nav ctaPrimary={ctaCopy.primary} />
      <PricingSection layout={tweaks.pricingLayout} />
      <FAQSection />
      <FinalCTA ctaPrimary={ctaCopy.primary} ctaSecondary={ctaCopy.secondary} />
      <Footer />
      {isAdmin ? <TweaksPanel /> : null}
    </>
  );
}
